@link fn getScissorMin() -> vec4<f32> {};
@link fn getScissorMax() -> vec4<f32> {};

@optional @link fn getBounds() -> vec4<f32> { return vec4<f32>(0.0, 0.0, 0.0, 0.0); };

@export fn getScissorBoxLevel(position: vec4<f32>, uv: vec4<f32>, st: vec4<f32>) -> vec4<f32> {

  let smin = getScissorMin();
  let smax = getScissorMax();

  var value: vec4<f32>;
  if (SCISSOR_BOX_INPUT == 1) {
    value = uv;
  }
  else if (SCISSOR_BOX_INPUT == 2) {
    value = st;
  }
  else {
    value = position;
  }

  let pmin = position - smin;
  let pmax = smax - position;

  return select(pmin, pmax, abs(pmin) > abs(pmax));
};
